import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  Button,
  Card,
  CardBody,
  Col,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap"
import { Form, Formik } from "formik"
import * as Yup from "yup"
import ViewDetails from "./ViewDetails"
import Select from "react-select"
import { getUserTypeInfo } from "helpers/authHelper"
import { SaveToast } from "components/Common/SaveToast"
import { IMAGE_URL } from "helpers/urlHelper"
import { useLocation, useParams } from "react-router-dom"
import SubmitLoader from "components/Common/SubmitLoader"
import {
  createTrainingQuestions,
  getTrainingQuestions,
  updateTrainingQuestions,
} from "helpers/backendHelpers/trainingQuestions"

import {
  getAllCategories,
  getAllSubCategories,
  getAllTopics,
  getSubCategories,
} from "helpers/backendHelpers/category"
import { section } from "common/data/dropdownVals"
import { getAllTrainingPrograms } from "helpers/backendHelpers/trainingProgram"

const AddEditAssigmentQuestion = props => {
  const location = useLocation()
  const type = location.state?.type
  const id = location.state?.id
  const [isEdit, setIsEdit] = useState(false)
  const [isView, setIsView] = useState(false)
  const [categoryValues, setCategoryValues] = useState([])
  const [subCategoryValues, setSubCategoryValues] = useState([])
  const [topicValues, setTopicValues] = useState([])
  const [TrainingQuestionId, setTrainingQuestionId] = useState(0)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [questionType, setQuestionType] = useState("mcq")
  const [questionStatement, setQuestionStatement] = useState("text")
  const [trainingPrograms, setTrainingPrograms] = useState([])
  const [trainingProgramsList, setTrainingProgramsList] = useState([])
  const [genreOptions, setGenreOptions] = useState([
    {
      value: "option1",
      label: "option1",
    },
    {
      value: "option2",
      label: "option2",
    },
    {
      value: "option3",
      label: "option3",
    },
    {
      value: "option4",
      label: "option4",
    },
    {
      value: "option5",
      label: "option5",
    },
  ])
  const [form, setForm] = useState({
    atq_title: "",
    atq_answerType: "",
    atq_mark: "",
    atq_option1: "",
    atq_option2: "",
    atq_option3: "",
    atq_option4: "",
    atq_option5: "",
    atq_correntAns: "",
    atq_correct: true,
    atq_questionType: "mcq",
    atq_questionStatement: "text",
    atq_image: { fileName: "", file: {} },
    // atq_category: "",
    // atq_subCategory: "",
    // atq_topic: "",
    atq_section: "",
    tp_id: "",
  })

  useEffect(() => {
    document.getElementById("training-questions").classList.add("mm-active")

    let { type, id } = props.match.params || {}
    // fetchCategoryDropDownValues()
    // fetchSubCategoryDropDownValues()
    // fetchTopicDropDownValues()
    setTrainingProgramDropDownValues()
    document.getElementById("mcq").checked = true

    if (document.getElementById("text")) {
      document.getElementById("text").checked = true
    }

    // if()
    switch (type) {
      case "edit":
        setIsEdit(true)
        setIsView(false)
        setTrainingQuestionId(parseInt(id))
        break
      case "view":
        setIsView(true)
        setIsEdit(false)
        setTrainingQuestionId(parseInt(id))
        break
      case "add":
        break
      default:
        setIsView(false)
        setIsEdit(false)
        setTrainingQuestionId(parseInt(id))
        break
    }

    if (id) {
      fetchTrainingQuestionDetailsForEdit(id)
    }
  }, [isEdit])

  // const fetchCategoryDropDownValues = async () => {
  //   try {
  //     let response = await getAllCategories()
  //     let { categories } = response.data || {}
  //     categories = categories || []
  //     let allCategory = []
  //     categories.map(category => {
  //       let item = category.category.map(data => {
  //         return {
  //           id: data.CategoryId,
  //           value: data.CategoryName,
  //         }
  //       })
  //       allCategory.push(...item)
  //     })
  //     setCategoryValues(allCategory)
  //     return
  //   } catch (error) {
  //     let message =
  //       error?.response?.data?.message ||
  //       error?.message ||
  //       "There was a problem fetching mainCategories"

  //     return SaveToast({ message, type: "error" })
  //   }
  // }

  // const fetchSubCategoryDropDownValues = async () => {
  //   try {
  //     let response = await getAllSubCategories()
  //     let { subCategories } = response.data || {}
  //     subCategories = subCategories || []
  //     let allSubCategory = []
  //     subCategories.map(subCategory => {
  //       let itemArr = []
  //       subCategory.category.map(data => {
  //         let item2 = data.subCategory.map(subData => {
  //           return {
  //             id: subData.subCateId,
  //             value: subData.subCateName,
  //           }
  //         })
  //         itemArr.push(...item2)
  //       })

  //       allSubCategory.push(...itemArr)
  //     })
  //     setSubCategoryValues(allSubCategory)
  //     return
  //   } catch (error) {
  //     let message =
  //       error?.response?.data?.message ||
  //       error?.message ||
  //       "There was a problem fetching mainCategories"

  //     return SaveToast({ message, type: "error" })
  //   }
  // }

  // const fetchTopicDropDownValues = async () => {
  //   try {
  //     let response = await getAllTopics()
  //     let { topics } = response.data || {}
  //     topics = topics || []
  //     let allTopicsData = []
  //     topics.map(topicItem => {
  //       let itemArr = []
  //       topicItem.category.map(data => {
  //         data.subCategory.map(subData => {
  //           let item2 = subData.topics.map(topicData => {
  //             return {
  //               id: topicData.topicId,
  //               value: topicData.topicName,
  //             }
  //           })
  //           itemArr.push(...item2)
  //         })
  //       })

  //       allTopicsData.push(...itemArr)
  //     })
  //     setTopicValues(allTopicsData)
  //     return
  //   } catch (error) {
  //     let message =
  //       error?.response?.data?.message ||
  //       error?.message ||
  //       "There was a problem fetching topics"

  //     return SaveToast({ message, type: "error" })
  //   }
  // }

  // const getAllSubCategoriesFromApi = async (filterCategory = "") => {
  //   try {
  //     let response = await getSubCategories()

  //     let { subCategories } = response.data
  //     let vals = []
  //     if (filterCategory) {
  //       subCategories.map(mainCategory => {
  //         let { category } = mainCategory
  //         category.map(Category => {
  //           let { subCategory } = Category
  //           if (Category.categoryName === filterCategory) {
  //             subCategory.map(cat => {
  //               vals.push({ name: cat.subCateName, value: cat.subCateName })
  //             })
  //           }
  //         })
  //       })
  //     } else {
  //       subCategories.map(mainCategory => {
  //         let { category } = mainCategory
  //         category.map(Category => {
  //           let { subCategory } = Category
  //           subCategory.map(cat => {
  //             vals.push({ name: cat.subCateName, value: cat.subCateName })
  //           })
  //         })
  //       })
  //       let tempVals = []
  //       vals.length > 0 &&
  //         vals.map((data, i) => {
  //           if (i < 4) {
  //             tempVals.push(data.value)
  //           }
  //         })
  //     }
  //     setSubCategoryValues(vals)
  //   } catch (error) {
  //     setError(error)
  //   }
  // }

  // const getAllTopicsFromApi = async (filterCategory = "") => {
  //   try {
  //     let response = await getAllTopics()
  //     let { topics } = response.data
  //     let vals = []
  //     if (filterCategory) {
  //       topics.map(mainCategory => {
  //         let { category } = mainCategory
  //         category.map(Category => {
  //           let { subCategory } = Category
  //           subCategory.map(subCat => {
  //             let { topics } = subCat
  //             if (subCat.subCateName === filterCategory) {
  //               topics.map(topic => {
  //                 vals.push({ name: topic.topicName, value: topic.topicName })
  //               })
  //             }
  //           })
  //         })
  //       })
  //     } else {
  //       topics.map(mainCategory => {
  //         let { category } = mainCategory
  //         category.map(Category => {
  //           let { subCategory } = Category
  //           subCategory.map(subCat => {
  //             let { topics } = subCat
  //             topics.map(topic => {
  //               vals.push({ name: topic.topicName, value: topic.topicName })
  //             })
  //           })
  //         })
  //       })
  //     }
  //     setTopicValues(vals)
  //   } catch (error) {
  //     setError(error)
  //   }
  // }

  const setTrainingProgramDropDownValues = async () => {
    try {
      const response = await getAllTrainingPrograms()
      let { trainingPrograms } = response.data || {}
      setTrainingProgramsList(trainingPrograms)
      let dropdownVals = trainingPrograms.map(tp => {
        return { value: tp.tp_id, label: tp.tp_programTitle }
      })
      dropdownVals = dropdownVals || []
      setTrainingPrograms(dropdownVals)
    } catch (error) {
      let message =
        error?.response?.data?.message ||
        error?.message ||
        "There Was A Problem Fetching BookGenre"

      setTrainingPrograms([])

      return SaveToast({ message, type: "error" })
    }
  }

  const fetchTrainingQuestionDetailsForEdit = async aq_id => {
    try {
      let response = await getTrainingQuestions(aq_id)

      let { allTrainingQue } = response.data || {}
      allTrainingQue = allTrainingQue || {}
      allTrainingQue["atq_image_old"] = allTrainingQue["atq_image"]
      allTrainingQue["atq_image"] = { fileName: "", file: {} }

      // getAllSubCategoriesFromApi(allTrainingQue?.atq_category)
      // getAllTopicsFromApi(allTrainingQue?.atq_subCategory)

      if (allTrainingQue.atq_questionType === "mcq") {
        if (document.getElementById("mcq")) {
          document.getElementById("mcq").checked = true
        }

        setQuestionType("mcq")
      } else if (allTrainingQue.atq_questionType === "theory") {
        if (document.getElementById("theory")) {
          document.getElementById("theory").checked = true
        }

        setQuestionType("theory")
      }

      if (allTrainingQue.atq_questionStatement === "text") {
        if (document.getElementById("text")) {
          document.getElementById("text").checked = true
        }

        setQuestionStatement("text")
      } else if (allTrainingQue.atq_questionStatement === "image") {
        if (document.getElementById("image")) {
          document.getElementById("image").checked = true
        }
        // document.getElementById("image").checked = true
        setQuestionStatement("image")
      }

      if (allTrainingQue?.atq_answerType == "text") {
      } else {
        if (allTrainingQue?.atq_correntAns?.length) {
          allTrainingQue.atq_correntAns = allTrainingQue.atq_correntAns.map(
            data => {
              return { label: data, value: data }
            }
          )
        }
      }

      // allTrainingQue["atq_correntAns"]
      if (isEdit) {
        if (allTrainingQue.atq_correct === true) {
          document.getElementById("option1").checked = true
          setCorrectAns(true)
        } else if (allTrainingQue.atq_correct === false) {
          document.getElementById("option2").checked = true
          setCorrectAns(false)
        } else if (allTrainingQue.atq_correct === false) {
          document.getElementById("option3").checked = true
          setCorrectAns(false)
        } else if (allTrainingQue.atq_correct === false) {
          document.getElementById("option4").checked = true
          setCorrectAns(false)
        } else if (allTrainingQue.atq_correct === false) {
          document.getElementById("option5").checked = true
          setCorrectAns(false)
        }
      }

      return setForm(allTrainingQue)
    } catch (error) {
      let message =
        error?.response?.data?.message ||
        error?.message ||
        "There was a problem fetching Training Questions"

      setForm(form)
      return SaveToast({ message, type: "error" })
    }
  }

  const handleAddAssigmentQuestionSubmit = async data => {
    try {
      setSubmitLoading(true)
      const response = await createTrainingQuestions(data)
      let message = response?.message || "Training Questions Added Successfully"
      SaveToast({ message, type: "success" })
      setSubmitLoading(false)
      props.history.push("/training-questions")
    } catch (error) {
      let message =
        error?.response?.data?.message ||
        error?.message ||
        "There Was A Problem Adding Training Questions"
      setSubmitLoading(false)
      return SaveToast({ message, type: "error" })
    }
  }

  const handleEditAssigmentQuestionSubmit = async (id, data) => {
    if (!id) {
      return SaveToast({
        message: "Please enter Training Questions Id",
        type: "error",
      })
    }
    try {
      setSubmitLoading(true)
      const response = await updateTrainingQuestions(id, data)
      let message =
        response?.message || "Training Questions Updated Successfully"
      SaveToast({ message, type: "success" })
      setSubmitLoading(false)
      props.history.push("/training-questions")
    } catch (error) {
      let message =
        error?.response?.data?.message ||
        error?.message ||
        "There Was A Problem Adding Training Questions"
      setSubmitLoading(false)
      return SaveToast({ message, type: "error" })
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div
          className="container-fluid"
          style={submitLoading ? { position: "relative", opacity: "0.8" } : {}}
        >
          {submitLoading ? <SubmitLoader /> : <></>}
          {isView ? (
            <>
              <ViewDetails {...props} />
            </>
          ) : (
            <Card>
              <CardBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={form}
                  validationSchema={Yup.object({
                    atq_mark:
                      form.atq_questionType == "mcq" &&
                      Yup.string().required("Please Select Marks"),

                    atq_answerType:
                      form.atq_questionType == "mcq" &&
                      Yup.string().required("Please Select correct answer"),
                    atq_title:
                      form.atq_questionType == "mcq" &&
                      Yup.string().required(
                        "Please Enter Assigment Question Title"
                      ),
                    // atq_category: Yup.string().required(
                    //   "Please Select Class/Grade"
                    // ),
                    // atq_subCategory: Yup.string().required(
                    //   "Please Select Subject"
                    // ),
                    // atq_topic: Yup.string().required("Please Select Topic"),
                    tp_id: Yup.string().required("Please Select Topic"),
                    atq_section:
                      type == 2 &&
                      Yup.string().required("Please Select Section"),
                    atq_option2:
                      form.atq_questionType == "mcq" &&
                      Yup.string().required("Please Enter option2 Title"),
                    atq_option1:
                      form.atq_questionType == "mcq" &&
                      Yup.string().required("Please Enter option1 Title"),
                    atq_questionStatement:
                      form.atq_questionType == "theory" &&
                      Yup.string().required("Please Select Question Statement"),
                  })}
                  onSubmit={values => {
                    let TrainingQuestion = values
                    let { atq_correntAns: CorrectAnswer } = values
                    if (isEdit) {
                      TrainingQuestion["atq_image_old"] = form.atq_image_old
                      TrainingQuestion["atq_image"] = form.atq_image.file

                      if (values?.atq_answerType == "multiple") {
                        CorrectAnswer = CorrectAnswer.map(data => {
                          return data.value
                        })
                        TrainingQuestion.atq_correntAns =
                          CorrectAnswer.toString()
                      } else if (values?.atq_answerType == "single") {
                        if (CorrectAnswer.length > 0) {
                          CorrectAnswer = CorrectAnswer[0].value
                          TrainingQuestion.atq_correntAns =
                            CorrectAnswer.toString()
                        } else {
                          TrainingQuestion.atq_correntAns =
                            CorrectAnswer?.value.toString()
                        }
                      } else {
                        if (Array.isArray(TrainingQuestion.atq_correntAns)) {
                          TrainingQuestion.atq_correntAns = TrainingQuestion
                            .atq_correntAns[0]
                            ? TrainingQuestion.atq_correntAns[0]
                            : null
                        } else {
                          TrainingQuestion.atq_correntAns =
                            TrainingQuestion.atq_correntAns
                        }
                      }

                      return handleEditAssigmentQuestionSubmit(
                        TrainingQuestionId,
                        TrainingQuestion
                      )
                    } else {
                      if (values?.atq_answerType == "multiple") {
                        CorrectAnswer = CorrectAnswer.map(data => {
                          return data.value
                        })
                        TrainingQuestion.atq_correntAns =
                          CorrectAnswer.toString()
                      } else if (values?.atq_answerType == "single") {
                        CorrectAnswer = CorrectAnswer?.value
                        TrainingQuestion.atq_correntAns =
                          CorrectAnswer.toString()
                      } else {
                        TrainingQuestion.atq_correntAns = TrainingQuestion
                          .atq_correntAns[0]
                          ? TrainingQuestion.atq_correntAns[0]
                          : null
                      }
                      TrainingQuestion["atq_image"] = form.atq_image?.file
                      return handleAddAssigmentQuestionSubmit(TrainingQuestion)
                    }
                  }}
                >
                  {({
                    touched,
                    errors,
                    values,
                    handleSubmit,
                    handleBlur,
                    handleChange,
                    setFieldValue,
                    setFieldTouched,
                  }) => (
                    <>
                      <Form
                        onSubmit={e => {
                          e.preventDefault()
                          handleSubmit(e)
                          return false
                        }}
                      >
                        <Row>
                          <Col>
                            <Row className="mb-3">
                              <Col
                                md={2}
                                sm={6}
                                xs={12}
                                className="mt-2 mt-md-0 mb-3"
                              >
                                <Label>Question Type</Label>
                                <br />
                                <Label className="form-label">MCQ</Label>
                                &nbsp;&nbsp;
                                <Input
                                  id="mcq"
                                  name="atq_questionType"
                                  type="radio"
                                  onChange={event => {
                                    if (event.target.checked) {
                                      let temp = form
                                      temp["atq_questionType"] = "mcq"
                                      values["atq_questionType"] = "mcq"
                                      setQuestionType("mcq")
                                      setQuestionStatement("text")
                                      setForm(temp)
                                    }
                                  }}
                                  onBlur={handleBlur}
                                  invalid={
                                    touched.atq_questionType &&
                                    errors.atq_questionType
                                  }
                                  value={form.atq_questionType}
                                  // defaultChecked
                                />
                                <br />
                                <Label className="form-label">Theory</Label>
                                &nbsp;&nbsp;
                                <Input
                                  id="theory"
                                  name="atq_questionType"
                                  type="radio"
                                  // value={false}
                                  onChange={event => {
                                    if (event.target.checked) {
                                      let temp = form
                                      temp["atq_questionType"] = "theory"
                                      values["atq_questionType"] = "theory"
                                      setQuestionType("theory")
                                      setForm(temp)
                                    }
                                  }}
                                  onBlur={handleBlur}
                                  invalid={
                                    touched.atq_questionType &&
                                    errors.atq_questionType
                                  }
                                  value={form.atq_questionType}
                                  // defaultChecked
                                />
                                {touched.atq_questionType &&
                                  errors.atq_questionType && (
                                    <FormFeedback>
                                      {errors.atq_questionType}
                                    </FormFeedback>
                                  )}
                              </Col>
                              <Col
                                md={2}
                                sm={6}
                                xs={12}
                                className="mt-2 mt-md-0 mb-3"
                              >
                                {questionType == "theory" && (
                                  <>
                                    <Label>Question Statement</Label>
                                    <br />
                                    <Label className="form-label">Text</Label>
                                    &nbsp;&nbsp;
                                    <Input
                                      id="text"
                                      name="atq_questionStatement"
                                      type="radio"
                                      onChange={event => {
                                        if (event.target.checked) {
                                          let temp = form
                                          temp["atq_questionStatement"] = "text"
                                          values["atq_questionStatement"] =
                                            "text"
                                          // setQuestionType('text')
                                          setQuestionStatement("text")
                                          setForm(temp)
                                        }
                                      }}
                                      onBlur={handleBlur}
                                      invalid={
                                        touched.atq_questionStatement &&
                                        errors.atq_questionStatement
                                      }
                                      value={form.atq_questionStatement}
                                      // defaultChecked
                                    />
                                    <br />
                                    <Label
                                      htmlFor="false"
                                      className="form-label"
                                    >
                                      Image
                                    </Label>
                                    &nbsp;&nbsp;
                                    <Input
                                      id="image"
                                      name="atq_questionStatement"
                                      type="radio"
                                      // value={false}
                                      onChange={event => {
                                        if (event.target.checked) {
                                          let temp = form
                                          temp["atq_questionStatement"] =
                                            "image"
                                          values["atq_questionStatement"] =
                                            "image"
                                          // setQuestionType('image')
                                          setQuestionStatement("image")

                                          setForm(temp)
                                        }
                                      }}
                                      onBlur={handleBlur}
                                      invalid={
                                        touched.atq_questionStatement &&
                                        errors.atq_questionStatement
                                      }
                                      value={form.atq_questionStatement}
                                      // defaultChecked
                                    />
                                    {touched.atq_questionStatement &&
                                      errors.atq_questionStatement && (
                                        <FormFeedback>
                                          {errors.atq_questionStatement}
                                        </FormFeedback>
                                      )}
                                  </>
                                )}
                              </Col>
                              {questionStatement == "text" && (
                                <Col
                                  md={4}
                                  sm={6}
                                  xs={12}
                                  className="mt-2 mt-md-0 mb-3"
                                >
                                  <Label className="form-label">
                                    Title
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    name="atq_title"
                                    type="text"
                                    placeholder="Enter Title"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    invalid={
                                      touched.atq_title && errors.atq_title
                                    }
                                    defaultValue={form.atq_title}
                                  />
                                  {touched.atq_title && errors.atq_title && (
                                    <FormFeedback>
                                      {errors.atq_title}
                                    </FormFeedback>
                                  )}
                                </Col>
                              )}
                              {questionStatement == "image" && (
                                <Col md={4} sm={6} xs={12} className="mb-3">
                                  <Label className="form-label">
                                    Image
                                    {isEdit && form?.atq_image_old && (
                                      <>
                                        <span className="ms-2">
                                          (
                                          <a
                                            href={`${IMAGE_URL}/${
                                              form?.atq_image_old || ""
                                            }`}
                                            target="_blank"
                                            rel="noreferrer"
                                          >
                                            Saved Image
                                          </a>
                                          )
                                        </span>
                                      </>
                                    )}
                                  </Label>
                                  <Input
                                    name="atq_image_old"
                                    type="file"
                                    accept=".png, .jpg, .jpeg, .gif"
                                    placeholder="Select Profile Pic"
                                    onChange={e => {
                                      let tempForm = form
                                      tempForm["atq_image"]["fileName"] =
                                        e.target.value
                                      tempForm["atq_image"]["file"] =
                                        e.target.files[0]
                                      setForm(tempForm)
                                    }}
                                    // // onBlur={handleBlur}
                                    invalid={
                                      touched.atq_image && errors.atq_image
                                    }
                                    defaultValue={form?.atq_image?.fileName}
                                  />
                                  {touched.atq_image && errors.atq_image && (
                                    <FormFeedback>
                                      {errors.atq_image}
                                    </FormFeedback>
                                  )}
                                </Col>
                              )}

                              {/* <Col
                                md={4}
                                sm={6}
                                xs={12}
                                className="mt-2 mt-md-0 mb-3"
                              >
                                <Label className="form-label">
                                  Live Session Date
                                  <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  name="aq_date"
                                  type="date"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  max={new Date().toJSON().slice(0, 10)}
                                  invalid={touched.aq_date && errors.aq_date}
                                  value={values.aq_date}
                                />
                                {touched.aq_date && errors.aq_date && (
                                  <FormFeedback>{errors.aq_date}</FormFeedback>
                                )}
                              </Col> */}
                              <Col md={4} sm={6} xs={12} className="mb-3">
                                <Label className="form-label">
                                  Select Training Program{" "}
                                  <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  name="tp_id"
                                  type="select"
                                  className="form-select"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.tp_id}
                                  invalid={
                                    touched.tp_id && errors.tp_id ? true : false
                                  }
                                >
                                  <option value="">
                                    Select Training Program
                                  </option>
                                  {trainingPrograms.map(val => {
                                    return (
                                      <option key={val.value} value={val.value}>
                                        {val.label}
                                      </option>
                                    )
                                  })}
                                </Input>
                                {!!touched.tp_id && !!errors.tp_id && (
                                  <FormFeedback>{errors.tp_id}</FormFeedback>
                                )}
                              </Col>
                              {questionType == "mcq" && (
                                <Col
                                  md={4}
                                  sm={6}
                                  xs={12}
                                  className="mt-2 mt-sm-0 mb-3"
                                >
                                  <Label className="form-label">
                                    Answer Type
                                  </Label>
                                  <Input
                                    name="atq_answerType"
                                    type="select"
                                    className="form-select"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.atq_answerType || 0}
                                    invalid={
                                      touched.atq_answerType &&
                                      errors.atq_answerType
                                        ? true
                                        : false
                                    }
                                  >
                                    <option value="0" disabled>
                                      Answer Type
                                    </option>

                                    <option value="single">
                                      Single Answer
                                    </option>
                                    <option value="multiple">
                                      Multiple Answer
                                    </option>
                                    <option value="text">text</option>
                                  </Input>
                                  {touched.atq_answerType &&
                                  errors.atq_answerType ? (
                                    <FormFeedback type="invalid">
                                      {errors.atq_answerType}
                                    </FormFeedback>
                                  ) : null}
                                </Col>
                              )}

                              <Col
                                md={4}
                                sm={6}
                                xs={12}
                                className="mt-2 mt-md-0 mb-3"
                              >
                                <Label className="form-label">
                                  Marks
                                  <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  name="atq_mark"
                                  type="text"
                                  placeholder="Enter  Marks"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  invalid={touched.atq_mark && errors.atq_mark}
                                  defaultValue={form.atq_mark}
                                />
                                {touched.atq_mark && errors.atq_mark && (
                                  <FormFeedback>{errors.atq_mark}</FormFeedback>
                                )}
                              </Col>
                              {type == 2 && (
                                <Col
                                  md={4}
                                  sm={6}
                                  xs={12}
                                  className="mt-2 mt-sm-0 mb-3"
                                >
                                  <Label className="form-label">Section</Label>
                                  <span className="text-danger">*</span>

                                  <Input
                                    name="atq_section"
                                    type="select"
                                    className="form-select"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.atq_section || 0}
                                    invalid={
                                      touched.atq_section && errors.atq_section
                                        ? true
                                        : false
                                    }
                                  >
                                    <option value="0" disabled>
                                      Select Section
                                    </option>
                                    {section.map(val => {
                                      return (
                                        <option key={val.id} value={val.value}>
                                          {val.label}
                                        </option>
                                      )
                                    })}
                                  </Input>
                                  {touched.atq_section && errors.atq_section ? (
                                    <FormFeedback type="invalid">
                                      {errors.atq_section}
                                    </FormFeedback>
                                  ) : null}
                                </Col>
                              )}

                              {/* <Col
                                md={4}
                                sm={6}
                                xs={12}
                                className="mt-2 mt-sm-0 mb-3"
                              >
                                <Label className="form-label">
                                  Class/Grade
                                  <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  name="atq_category"
                                  type="select"
                                  className="form-select"
                                  onChange={e => {
                                    handleChange(e)
                                    getAllSubCategoriesFromApi(e.target.value)
                                    values.atq_subCategory = ""
                                    values.atq_topic = ""
                                  }}
                                  onBlur={handleBlur}
                                  value={values.atq_category || 0}
                                  invalid={
                                    touched.atq_category && errors.atq_category
                                      ? true
                                      : false
                                  }
                                >
                                  <option value="0" disabled>
                                    Select Class/Grade
                                  </option>
                                  {categoryValues.map(val => {
                                    return (
                                      <option key={val.id} value={val.value}>
                                        {val.value}
                                      </option>
                                    )
                                  })}
                                </Input>
                                {touched.atq_category && errors.atq_category ? (
                                  <FormFeedback type="invalid">
                                    {errors.atq_category}
                                  </FormFeedback>
                                ) : null}
                              </Col>

                              <Col
                                md={4}
                                sm={6}
                                xs={12}
                                className="mt-2 mt-sm-0 mb-3"
                              >
                                <Label className="form-label">
                                  Subject
                                  <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  name="atq_subCategory"
                                  type="select"
                                  className="form-select"
                                  onChange={e => {
                                    handleChange(e)
                                    getAllTopicsFromApi(e.target.value)
                                    values.atq_topic = ""
                                  }}
                                  onBlur={handleBlur}
                                  value={values.atq_subCategory || 0}
                                  invalid={
                                    touched.atq_subCategory &&
                                    errors.atq_subCategory
                                      ? true
                                      : false
                                  }
                                >
                                  <option value="0" disabled>
                                    Select Subject
                                  </option>
                                  {subCategoryValues.map(val => {
                                    return (
                                      <option key={val.id} value={val.value}>
                                        {val.value}
                                      </option>
                                    )
                                  })}
                                </Input>
                                {touched.atq_subCategory &&
                                errors.atq_subCategory ? (
                                  <FormFeedback type="invalid">
                                    {errors.atq_subCategory}
                                  </FormFeedback>
                                ) : null}
                              </Col>

                              <Col
                                md={4}
                                sm={6}
                                xs={12}
                                className="mt-2 mt-sm-0 mb-3"
                              >
                                <Label className="form-label">Topics</Label>
                                <span className="text-danger">*</span>

                                <Input
                                  name="atq_topic"
                                  type="select"
                                  className="form-select"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.atq_topic || 0}
                                  invalid={
                                    touched.atq_topic && errors.atq_topic
                                      ? true
                                      : false
                                  }
                                >
                                  <option value="0" disabled>
                                    Select Topic
                                  </option>
                                  {topicValues.map(val => {
                                    return (
                                      <option key={val.id} value={val.value}>
                                        {val.value}
                                      </option>
                                    )
                                  })}
                                </Input>
                                {touched.atq_topic && errors.atq_topic ? (
                                  <FormFeedback type="invalid">
                                    {errors.atq_topic}
                                  </FormFeedback>
                                ) : null}
                              </Col> */}

                              {questionType == "mcq" && (
                                <>
                                  <Col
                                    md={4}
                                    sm={6}
                                    xs={12}
                                    className="mt-2 mt-md-0 mb-3"
                                  >
                                    <Label className="form-label">
                                      option 1
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      name="atq_option1"
                                      type="text"
                                      placeholder="option 1"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      invalid={
                                        touched.atq_option1 &&
                                        errors.atq_option1
                                      }
                                      defaultValue={form.atq_option1}
                                    />
                                    {touched.atq_option1 &&
                                      errors.atq_option1 && (
                                        <FormFeedback>
                                          {errors.atq_option1}
                                        </FormFeedback>
                                      )}
                                  </Col>
                                  <br />
                                  <Col
                                    md={4}
                                    sm={6}
                                    xs={12}
                                    className="mt-2 mt-md-0 mb-3"
                                  >
                                    <Label className="form-label">
                                      option 2
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      name="atq_option2"
                                      type="text"
                                      placeholder="option 2"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      invalid={
                                        touched.atq_option2 &&
                                        errors.atq_option2
                                      }
                                      defaultValue={form.atq_option2}
                                    />
                                    {touched.atq_option2 &&
                                      errors.atq_option2 && (
                                        <FormFeedback>
                                          {errors.atq_option2}
                                        </FormFeedback>
                                      )}
                                  </Col>
                                  <br />
                                  <Col
                                    md={4}
                                    sm={6}
                                    xs={12}
                                    className="mt-2 mt-md-0 mb-3"
                                  >
                                    <Label className="form-label">
                                      option 3
                                    </Label>
                                    <Input
                                      name="atq_option3"
                                      type="text"
                                      placeholder="option 3"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      invalid={
                                        touched.atq_option3 &&
                                        errors.atq_option3
                                      }
                                      defaultValue={form.atq_option3}
                                    />
                                    {/* {touched.atq_option3 && errors.atq_option3 && (
                                <FormFeedback>{errors.atq_option3}</FormFeedback>
                              )} */}
                                  </Col>
                                  <Col
                                    md={4}
                                    sm={6}
                                    xs={12}
                                    className="mt-2 mt-md-0 mb-3"
                                  >
                                    <Label className="form-label">
                                      option 4
                                    </Label>
                                    <Input
                                      name="atq_option4"
                                      type="text"
                                      placeholder="option 4"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      invalid={
                                        touched.atq_option4 &&
                                        errors.atq_option4
                                      }
                                      defaultValue={form.atq_option4}
                                    />
                                    {/* {touched.atq_option4 && errors.atq_option4 && (
                                <FormFeedback>{errors.atq_option4}</FormFeedback>
                              )} */}
                                  </Col>
                                  <br />
                                  <Col
                                    md={4}
                                    sm={6}
                                    xs={12}
                                    className="mt-2 mt-md-0 mb-3"
                                  >
                                    <Label className="form-label">
                                      option 5
                                    </Label>
                                    <Input
                                      name="atq_option5"
                                      type="text"
                                      placeholder="option 5"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      invalid={
                                        touched.atq_option5 &&
                                        errors.atq_option5
                                      }
                                      defaultValue={form.atq_option5}
                                    />
                                    {/* {touched.atq_option5 && errors.atq_option5 && (
                                <FormFeedback>{errors.atq_option5}</FormFeedback>
                              )} */}
                                  </Col>
                                  <Col md={4} sm={6} xs={12} className="mb-3">
                                    <Label className="form-label">
                                      Correct Answer
                                      <span className="text-danger">*</span>
                                    </Label>
                                    {values.atq_answerType != "text" ? (
                                      <>
                                        <Select
                                          name="atq_correntAns"
                                          options={genreOptions}
                                          value={values.atq_correntAns}
                                          validate={{
                                            required: { value: true },
                                          }}
                                          onChange={value => {
                                            setFieldValue(
                                              "atq_correntAns",
                                              value ? value : ""
                                            )
                                          }}
                                          onBlur={evt => {
                                            setFieldTouched(
                                              "atq_correntAns",
                                              true,
                                              true
                                            )
                                          }}
                                          className="react-select-container"
                                          classNamePrefix="select2-selection"
                                          // invalid={
                                          //   !!touched.atq_correntAns &&
                                          //   !!errors.atq_correntAns
                                          // }
                                          invalid={
                                            touched.atq_correntAns &&
                                            errors.atq_correntAns
                                              ? true
                                              : false
                                          }
                                          placeholder="Type to search..."
                                          isMulti={
                                            values.atq_answerType == "multiple"
                                              ? true
                                              : false
                                          }
                                          isClearable
                                          isSearchable
                                        />
                                        {!!touched.atq_correntAns &&
                                        !!errors.atq_correntAns ? (
                                          <div className="invalid-react-select-dropdown">
                                            {errors.atq_correntAns}
                                          </div>
                                        ) : null}
                                      </>
                                    ) : (
                                      <>
                                        <Input
                                          name="atq_correntAns"
                                          type="textarea"
                                          rows={6}
                                          placeholder="Enter Correct Answer"
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          invalid={
                                            touched.atq_correntAns &&
                                            errors.atq_correntAns
                                          }
                                          defaultValue={form.atq_correntAns[0]}
                                        />
                                      </>
                                    )}
                                  </Col>
                                </>
                              )}
                            </Row>
                            <Row className="mb-3 text-center">
                              <Col>
                                <Button
                                  size="md"
                                  color="danger"
                                  type="button"
                                  disabled={submitLoading}
                                  className="mx-2"
                                  onClick={() => {
                                    props.history.push("/training-questions")
                                  }}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  size="md"
                                  color="info"
                                  type="submit"
                                  disabled={submitLoading}
                                >
                                  {!isEdit ? "Save" : "Update"}
                                </Button>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Form>
                    </>
                  )}
                </Formik>
              </CardBody>
            </Card>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

AddEditAssigmentQuestion.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
}

export default AddEditAssigmentQuestion
